<template>
    <div>
        <div class="locations">
            <div class="form locations__search">
                <div class="field">
                    <div class="control">
                        <button class="button" @click="getLocation">Use My Location</button>
                        <br>
                        or
                    </div>
                </div>
                <div class="field">
                    <div class="control">
                        <input type="text" class="input input--fullwidth" name="location" placeholder="Street, City, State, or Zip" v-model="form.address" @keyup.enter="getAddressLocation">
                    </div>
                </div>
                <div class="field">
                    <div class="control">
                        <div class="select select--fullwidth">
                            <select name="chains" class="select" v-model="form.chain">
                                <option value="">All Retail Chains</option>
                                <option v-for="chain in chains" :value="chain.id">{{ chain.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="field">
                    <div class="control">
                        <button class="button" type="button" @click="getAddressLocation">Submit</button>
                    </div>
                </div>
            </div>
            <div class="locations__results" ref="results">
                <ul>
                    <li v-for="location in locations">
                        <div class="locations__results__title">{{ location.location_name }}</div>
                        <div class="locations__results__address" v-html="location.full_address"></div>
                        <div v-if="location.distance" class="locations__results__distance" v-html="location.distance"></div>
                        <a href="javascript:void(0)" @click="viewLocation(location)">View on map</a>
                    </li>
                    <infinite-loading :identifier="infiniteId" @infinite="getRequest" spinner="spiral"></infinite-loading>
                </ul>
            </div>
            <div class="locations__map-section">
                <div class="locations__map">
                    <div>
                        <leaflet :locations="locations"></leaflet>
                    </div>
                </div>
            </div>
        </div>
        <div class="chains">
            <h5>Click on logos below to find the locations near you</h5>
            <div class="chain-grid">
                <div v-for="chain in chains" v-if="chain.photo" class="chain" :class="{'chain--active': chain_filter === chain.id}" @click="filterChain(chain.id)">
                    <div class="image image--1by1">
                        <img :src="chain.logo_url" :alt="chain.name" />
                    </div>
                    {{ chain.name }}
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {EventBus} from '../event-bus';
    import InfiniteLoading from 'vue-infinite-loading';

    export default {
        name: 'RetailLocationsSearch', // props: ['chains', 'locations'],
        components: {
            InfiniteLoading,
        },
        props: ['chains'],
        data() {
            return {
                page: 1,
                locations: [],
                chain_filter: null,
                form: {
                    address: '',
                    chain: '',
                },
                lat: null,
                long: null,
                infiniteId: +new Date(),
            };
        },
        methods: {
            viewLocation(location) {
                EventBus.$emit('view-location', location.id, location.location_coordinates);
            },
            getLocation() {
                let vm = this;
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function(position) {
                        vm.lat = position.coords.latitude;
                        vm.long = position.coords.longitude;
                        vm.getRequest();
                    }, function(err) {
                        console.log(err);
                    });
                } else {
                    console.log('No Location!');
                }
            },
            getAddressLocation() {
                let vm = this;
                if (vm.form.address !== '') {
                    vm.chain_filter = vm.form.chain;
                    let searchParams = new URLSearchParams();
                    searchParams.set('q', vm.form.address);
                    searchParams.set('countrycodes', 'us');
                    searchParams.set('format', 'json');

                    let url = `https://nominatim.openstreetmap.org/search?${searchParams.toString()}`;

                    vm.$http.get(url).then(function(data) {
                        if (data.data.length > 0 && data.data[0].lat && data.data[0].lon) {
                            vm.lat = data.data[0].lat;
                            vm.long = data.data[0].lon;
                            vm.resetSearch();
                        }
                    });
                } else if (vm.chain_filter !== vm.form.chain) {
                    vm.chain_filter = vm.form.chain;
                    vm.resetSearch();
                }
            },
            filterChain(chain) {
                let vm = this;
                vm.chain_filter = chain;
                vm.form.chain = chain;
                vm.resetSearch();
            },
            resetSearch() {
                this.page = 1;
                this.locations = [];
                this.infiniteId += 1;
                this.$refs.results.scrollTop = 0;
            },
            getRequest($state) {
                let vm = this;
                this.$http.get('/about-us/locations/json', {
                    params: {
                        page: this.page,
                        chain: vm.chain_filter,
                        lat: vm.lat,
                        long: vm.long,
                    },
                }).then(({data}) => {
                    if (vm.locations.length !== data.total) {
                        vm.locations.push(...data.data);
                    }

                    if (data.next_page_url) {
                        vm.page += 1;
                        if ($state) {
                            $state.loaded();
                        }
                    } else {
                        if ($state) {
                            $state.complete();
                        }
                    }
                });
            },
        },
    };
</script>
